<template>
    <!-- app -->
    <div id="ModalBookingNew" class="client-invite-modal new-book-modal">
        <!-- use the modal component, pass in the prop -->
        <modal v-if="showModal" @close="showModal = false">
            <transition name="modal">
                <div class="modal-mask">
                    <div class="modal-wrap">
                        <div class="modal-dialog">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <button type="button" class="close" @click="closeModal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                    <div class="row">
                                        <div class="col-xs-2">
                                            <img class="modal-logo" v-bind:src="templateDirectory + '/images/' + logo">
                                        </div>
                                        <div class="col-xs-8">
                                            <h3 v-if="screen!='reset-password'" class="modal-headline">
                                                Book with 
                                                <span v-if="profile.group_member_aliases.length==1">{{profile.first_name}} {{profile.last_name}}</span>
                                                <b-dropdown v-if="profile.group_member_aliases.length>1" :text="profile.first_name+' '+profile.last_name" class="stylist-name-dropdown">
                                                    <b-dropdown-item v-for="(member, i) in profile.group_member_aliases" :key="i" v-on:click="onProfileChange(member.alias, member.name)">{{member.name}}</b-dropdown-item>
                                                </b-dropdown>
                                            </h3>

                                            </h3>
                                            <h3 v-if="screen=='reset-password'" class="modal-headline">Recover Password</h3>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal-body" :class="{'with-background': (screen=='login' || screen=='register' || screen=='verify-phone' || screen=='user-exists' || screen=='reset-password' || screen=='request-code')}">
                                    <slot v-if="!blocked" name="body text-left">
                                        <div v-if="screen=='step-1'" class="step-1-screen">
                                            <div class="step-1-services-wrap">
                                                <div class="selected-services-detail">
                                                    <div v-if="booking_service_names.length==0" class="service-names">
                                                        No services selected
                                                    </div>
                                                    <div v-if="booking_service_names.length>0" class="service-names">
                                                        {{ booking_service_names.join(', ') }}
                                                    </div>
                                                    <div v-if="booking_service_names.length>0" class="service-detail">
                                                        <span v-if="profile.display_prices">
                                                            <span v-if="profile.currency=='USD'">${{ booking_services_total_cost }} </span>
                                                            <span v-if="profile.currency!='USD'">{{ booking_services_total_cost }} {{ profile.currency }} </span>
                                                            {{ (booking_services_and_up) ? ' and up,':',' }}
                                                        </span>
                                                        <span>
                                                            {{ booking_services_total_duration }} minutes
                                                        </span>
                                                    </div>
                                                </div>
                                                <div class="select-new-services-wrap">
                                                    <span v-if="!appointment_saved" class="action-link" :class="{'no-services':booking_service_names.length==0}" v-on:click="onAddService">+ Add Service</span>
                                                </div>
                                            </div>

                                            <div v-if="!showMoreDates" class="step-1-dates-wrap text-left">
                                                <div v-for="(date, index) in available_dates" :key="index" class="available-date" :data-up="slotsPosUpdates">
                                                    <div class="date">{{ date.date | moment('dddd, MMM D') }}</div>
                                                    <div :ref="`slots-ref-1-${index}`" class="slots-wrap">
                                                        <div v-if="date.slots.length>5" v-on:click="slotsMoveLeft(index, $refs['slots-ref-1-'+index][0].clientWidth/2)" class="slots-left">&lt;</div>
                                                        <div class="slots has-more" :class="{'has-more': (date.slots.length>5)}">
                                                            <div :ref="`slots-inner-ref-1-${index}`" class="slots-inner" :style="{'width': (94*date.slots.length)+'px', 'left': (slotsPos[index])+'px'}">
                                                                <span v-on:click="onSelectTime(slot, date.date)" class="slot" v-for="(slot, i) in date.slots" :key="i">{{ slot }}</span>
                                                            </div>
                                                        </div>
                                                        <div v-if="date.slots.length>5" v-on:click="slotsMoveRight(index, $refs['slots-ref-1-'+index][0].clientWidth/2, -($refs['slots-inner-ref-1-'+index][0].clientWidth - $refs['slots-ref-1-'+index][0].clientWidth + 20))" class="slots-right">&gt;</div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div v-if="showMoreDates && !booking_date_time" class="step-1-more-dates-wrap text-left">
                                                <div class="step-1-more-dates-wrap-inner">
                                                    <div class="book-caledar-wrapper">
                                                        <datepicker @selected="getStylistFreeHours" :inline="true" :disabledDates="disabledDates"></datepicker>
                                                    </div>
                                                    <div class="book-date-time">
                                                        <div v-if="booking_date" class="selected-date">
                                                            {{ booking_date | moment('ddd, MMM D, Y') }}
                                                        </div>
                                                        <div class="free-hours">
                                                            <div v-for="(group, index) in free_hours_group_names" :key="index" class="free-hours-group" :data-up="slotsPosUpdates">
                                                                <h4 v-if="free_hours_groups[group].length>0" class="group-name">{{ group }}</h4>
                                                                <div :ref="`slots-ref-2-${index}`" v-if="free_hours_groups[group].length>0" class="slots-wrap">
                                                                    <div v-if="free_hours_groups[group].length>2" v-on:click="slotsMoveLeft(index, $refs['slots-ref-2-'+index][0].clientWidth/2)" class="slots-left">&lt;</div>
                                                                    <div class="slots has-more" :class="{'has-more': (free_hours_groups[group].length>2)}">
                                                                        <div :ref="`slots-inner-ref-2-${index}`" class="slots-inner" :style="{'width': (94*free_hours_groups[group].length)+'px', 'left': (slotsPos[index])+'px'}">
                                                                            <span v-on:click="onSelectTime(slot)" class="slot" v-for="(slot, i) in free_hours_groups[group]" :key="i">{{ slot }}</span>
                                                                        </div>
                                                                    </div>
                                                                    <div v-if="free_hours_groups[group].length>2" v-on:click="slotsMoveRight(index, $refs['slots-ref-2-'+index][0].clientWidth/2, -($refs['slots-inner-ref-2-'+index][0].clientWidth - $refs['slots-ref-2-'+index][0].clientWidth + 40))" class="slots-right">&gt;</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-if="unavailable_service_name_days.length>0" class="unavailable-service-days">
                                                    <p v-for="(item, i) in unavailable_service_name_days" :key="i"><span v-if="item.days.length>0"><b>{{ item.service }}</b> is not available on {{ item.days.join(', ') }}.</span></p>
                                                </div>
                                            </div>

                                            <div v-if="showMoreDates && booking_date_time" class="step-1-datetime-selected text-left">
                                                <span v-if="!appointment_saved" v-on:click="onEditTime" class="datetime-edit action-link">Edit</span>
                                                <h4 class="selected-date">{{ getFormattedDate(booking_date_time, 'dddd, MMM D') }}</h4>
                                                <p>{{ getFormattedDate(booking_date_time, 'h:mm a') }} - {{ getFormattedDate(booking_end_date_time, 'h:mm a') }}</p>
                                            </div>

                                            <div v-if="showMoreDates && booking_date_time && !appointment_saved" class="step-1-final text-left">
                                                <div class="notes-wrap">
                                                    <div>Add notes to {{ profile.first_name }}</div>
                                                    <div class="notes-input-wrap">
                                                        <input v-model="booking_notes" class="notes-input" type="text" name="notes">
                                                    </div>
                                                </div>
                                                <div v-if="hasPolicyEnabled() && profile.logged_in" class="policy-note">
                                                    <div v-if="profile.logged_in && has_card && profile.policy.deposit!=0 && profile.policy.deposit_fee!=0">
                                                        <p>Your card will be charged with the deposit fee: <strong><span>{{ (profile.currency=='USD') ? '$' : profile.currency+' ' }}</span>{{ deposit_fee }}</strong></p>
                                                    </div>
                                                    <div v-if="profile.logged_in && !has_card">
                                                        <h4>{{ profile.first_name }} {{ profile.last_name }} requires a credit card to hold this reservation</h4>
                                                        <p v-if="profile.policy.deposit==0 || profile.policy.deposit_fee==0">Your card will not be charged, services payment will be collected after rendering the services.</p>
                                                        <p v-if="profile.policy.deposit!=0 && profile.policy.deposit_fee!=0">Your card will be charged with the deposit fee: <strong><span>{{ (profile.currency=='USD') ? '$' : profile.currency+' ' }}</span>{{ deposit_fee }}</strong></p>

                                                        <div v-if="profile.accept_stripe" class="card-form" ref="card_form"></div>
                                                        <div v-if="profile.accept_square && !profile.accept_stripe" class="card-form card-form-square" ref="card_form_square">
                                                            <div id="sq-card-number"></div>
                                                            <div class="third" id="sq-expiration-date"></div>
                                                            <div class="third" id="sq-cvv"></div>
                                                            <div class="third" id="sq-postal-code"></div>
                                                        </div>
                                                        <div v-if="profile.accept_paypal && !profile.accept_stripe && !profile.accept_square" class="card-form card-form-paypal" ref="card_form_paypal">
                                                            <div id="paypal-button"></div>
                                                        </div>
                                                        <div class="card-logos">
                                                            <img class="logos" v-bind:src="templateDirectory + '/images/card-logos.png'">
                                                            <img class="verified" v-bind:src="templateDirectory + '/images/verified-secured.jpg'">
                                                        </div>
                                                        <div class="card-errors">{{ cards_errors }}</div>
                                                    </div>
                                                    <div v-if="profile.policy && profile.policy.cancel==1 && profile.policy.cancel_fee>0">
                                                        <h4>Cancellation Policy</h4>
                                                        <p>You will not be charged if you cancel at least {{ profile.policy.cancel_advance_hours }} hours before your appointment starts. Otherwise, you will be charged up to {{ profile.policy.cancel_fee }}% of the services booked.</p>
                                                    </div>
                                                </div>
                                                <div class="action-buttons-wrap">
                                                    <button v-if="!profile.logged_in" v-on:click="screen='login'" type="button" class="book-button">Login or Register</button>
                                                    <button v-if="profile.logged_in" v-on:click="handleSaveAppointment" :disabled="(booking_service_names.length==0 || loading)" type="button" class="book-button">{{ (!loading) ? 'Book Now' : 'Saving...' }}</button>
                                                </div>
                                                <div v-if="appointment_message" v-html="appointment_message" class="appt-message"></div>
                                            </div>

                                            <div v-if="appointment_saved" class="appt-message-wrap text-centr">
                                                <p>Thank you <span class="client-user-name">{{user.first_name}}</span>!</p>
                                                <p>Your appointment was scheduled for <span id="appt-date">{{booking_date | moment('MMM D, Y') }}</span> at <span id="appt-time">{{booking_hour}}</span></p>
                                                <p v-if="profile.auto_confirm_appointments==0">As soon as {{profile.first_name}} will confirm your appointment you will receive a text message with the confirmation.</p>
                                                <span v-on:click="closeModal" class="action-link">Thank you!</span>
                                            </div>

                                            <div v-if="!showMoreDates" class="text-left">
                                                <span v-on:click="showMoreDates=true" class="action-link">Click here to view more dates</span>
                                            </div>
                                        </div>

                                        <div v-if="screen=='select-services'" class="select-services-screen">
                                            <div class="select-services-head">
                                                <span v-on:click="onServicesClose" class="action-link select-services-close">CLOSE</span>
                                                <span class="select-services-title">Select Services</span>
                                                <span v-on:click="onServicesSave" class="action-link select-services-save">SAVE</span>
                                            </div>
                                            <div class="select-services-wrap text-left">
                                                <div class="service-category">
                                                    <ul v-if="profile.book_modal_template!=2" class="category-services-list">
                                                        <li v-for="service in profile.services">
                                                            <label class="switch">
                                                                <input type="checkbox" class="book-service" :value="service.id" v-model="booking_services_edit">
                                                                <span class="slider round"></span>
                                                            </label>
                                                            <div>
                                                                <span class="service-title">{{service.name}}</span>
                                                                <div v-if="service.description" class="service-desc">
                                                                    {{service.description}}
                                                                </div>
                                                                <p class="service-desc">
                                                                    <span v-if="profile.display_prices">
                                                                        <span v-if="profile.currency=='USD'">${{ service.price_default }} </span>
                                                                        <span v-if="profile.currency!='USD'">{{ service.price_default }} {{ profile.currency }} </span>
                                                                        {{ (service.price_and_up) ? ' and up,':',' }}
                                                                    </span>
                                                                    <span>
                                                                        {{ service.duration_default }} minutes
                                                                    </span>
                                                                </p>
                                                            </div>
                                                        </li>
                                                    </ul>

                                                    <div v-if="profile.book_modal_template==2" class="service-category-list">
                                                        <div v-for="category in profile.categories" v-if="category.services.length>0 || !category.id" class="stylist-services-block full-width">
                                                            <h3 class="service-block-title">{{category.name}}</h3>
                                                            <div class="line-sep"></div>
                                                            <ul class="category-services-list">
                                                                <li v-for="service in category.services">
                                                                    <label class="switch">
                                                                        <input type="checkbox" class="book-service" :value="service.id" v-model="booking_services_edit">
                                                                        <span class="slider round"></span>
                                                                    </label>
                                                                    <div>
                                                                        <span class="service-title">{{service.name}}</span>
                                                                        <div v-if="service.description" class="service-desc">
                                                                            {{service.description}}
                                                                        </div>
                                                                        <p class="service-desc">
                                                                            <span v-if="profile.display_prices">
                                                                                <span v-if="profile.currency=='USD'">${{ service.price_default }} </span>
                                                                                <span v-if="profile.currency!='USD'">{{ service.price_default }} {{ profile.currency }} </span>
                                                                                {{ (service.price_and_up) ? ' and up,':',' }}
                                                                            </span>
                                                                            <span>
                                                                                {{ service.duration_default }} minutes
                                                                            </span>
                                                                        </p>
                                                                    </div>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div v-if="screen=='login'" class="login-section form-section">
                                            <div class="login-form-row email-login-row">
                                                <input id="email-login" type="email" v-model="login_email" name="email" placeholder="Email" />
                                                <span class="input-stripe-border"></span>
                                            </div>
                                            <div class="login-form-row password-login-row">
                                                <input id="password-login" type="password" v-model="login_password" name="password" placeholder="Password" />
                                                <span class="input-stripe-border"></span>
                                            </div>
                                            <div class="row">
                                                <div class="col-sm-12 action-buttons-wrap text-center">
                                                    <button @click="loginAppUser" class="book-button">Login</button>
                                                </div>
                                            </div>
                                            <div class="row login-form-row">
                                                <div v-if="login_message" v-html="login_message" class="col-sm-12"></div>
                                            </div>
                                            <div class="login-form-row text-center">
                                                <span class="action-link" v-on:click="screen='reset-password'">Forgot password?</span>
                                            </div>
                                            <div v-if="profile.work_settings.accept_new_clients!==0" class="col-sm-12 forgot-password-text text-center">
                                                <span>Don't have an account yet? </span><span class="action-link" v-on:click="screen='register'">Register Now</span>
                                            </div>
                                        </div>

                                        <div v-if="screen=='reset-password'" class="login-section form-section">
                                            <div class="login-form-row email-login-row text-left">
                                                Please enter your email address and we will send you an email with a link to reset your password.
                                            </div>
                                            <div class="login-form-row email-login-row">
                                                <input id="email-login" type="email" v-model="login_email" name="email" placeholder="Email" />
                                                <span class="input-stripe-border"></span>
                                            </div>
                                            <div class="row">
                                                <div class="col-sm-6 action-buttons-wrap text-center">
                                                    <button @click="screen='login'" class="book-button">Back to Login</button>
                                                </div>
                                                <div class="col-sm-6 action-buttons-wrap text-center">
                                                    <button @click="sendResetPasswordEmail" :disabled="!login_email" class="book-button">Send Email</button>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-sm-12">
                                                    <div class="reset-pass-options">
                                                        <span class="link-separator"> -or- </span>
                                                        <a class="book-action-link" href="#" @click="screen='request-code'">Request Code</a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row login-form-row">
                                                <div v-html="reset_pass_message" class="col-sm-12"></div>
                                            </div>
                                        </div>

                                        <div v-if="screen=='request-code'" class="login-section form-section">
                                            <div class="login-form-row login-phone-row text-center">
                                                <input v-model="login_phone_mask" v-mask="'(###) ###-####'" type="text" name="phone" placeholder="Mobile Phone Number" class="login-phone-input">
                                                <span class="input-stripe-border"></span>
                                            </div>
                                            <div class="text-center login-form-row">
                                                <button type="button" class="book-button" @click="onRequestCode" tabindex="10">Request Code</button>
                                            </div>
                                            <div class="text-center">
                                                <span class="action-link" v-on:click="screen='login'">Back to Login</span>
                                            </div>
                                            <div v-if="phone_check_message" v-html="phone_check_message"></div>
                                        </div>

                                        <div v-if="screen=='register'" class="register-section form-section">
                                            <div class="login-form-row email-login-row">
                                                <input type="text" v-model="register_name" name="name" placeholder="First Name & Last Name" />
                                                <span class="input-stripe-border"></span>
                                            </div>
                                            <div class="login-form-row email-login-row">
                                                <input type="email" v-model="register_email" v-on:focusout="checkExistingUser" name="email" placeholder="Email" />
                                                <span class="input-stripe-border"></span>
                                            </div>
                                            <div class="login-form-row password-login-row">
                                                <input type="password" v-model="register_password" name="password" placeholder="Password" />
                                                <span class="input-stripe-border"></span>
                                            </div>
                                            <div class="login-form-row password-login-row">
                                                <div class="d-flex">
                                                    <div class="dropdown">
                                                        <span class="btn btn-light dropdown-toggle" id="phonePrefixes" tabindex="0" v-on:focus="show_prefixes_dropdown=1" v-on:focusout="show_prefixes_dropdown=0">
                                                            {{ phonePrefix }}
                                                        </span>
                                                        <div v-if="countries.length>0" :class="{'show': show_prefixes_dropdown}" class="prefixes-dropdown dropdown-menu" aria-labelledby="phonePrefixes">
                                                            <a class="dropdown-item" v-for="(prefix, index) in countries" v-bind:key="index" v-on:mousedown="phonePrefix=prefix;show_prefixes_dropdown==0">{{ prefix }}</a>
                                                        </div>
                                                    </div>
                                                    <div class="d-flex align-items-center justify-content-center phone-dash p-2">-</div>
                                                    <input v-model="register_phone_mask" v-mask="'(###) ###-####'" v-on:change="phone_verified=false;updateRegisterPhone()" v-on:focusout="checkExistingUser" type="text" name="phone">
                                                </div>
                                                <span class="input-stripe-border"></span>
                                            </div>
                                            <div class="login-form-row email-login-row">
                                                <input type="text" v-model="register_zip" name="zip" placeholder="ZIP Code" />
                                                <span class="input-stripe-border"></span>
                                            </div>
                                            <div class="row">
                                                <div class="col-sm-12 action-buttons-wrap text-center">
                                                    <button @click="registerAppUser" class="book-button">Register</button>
                                                </div>
                                            </div>
                                            <div class="row login-form-row">
                                                <div v-html="register_message" class="col-sm-12"></div>
                                            </div>
                                            <div class="login-form-row text-center">
                                                <div>By continuing you are indicating that you have read and agree to the</div>
                                                <div>
                                                    <a target="_blank" class="action-link" href="https://www.ringmyloctician.com/terms-and-condition">Terms of Service</a> &amp;
                                                    <a target="_blank" class="action-link" href="https://www.ringmyloctician.com/privacy-policy">Privacy Policy</a>
                                                </div>
                                            </div>
                                            <div class="col-sm-12 forgot-password-text text-center">
                                                <span>Already have an account? </span><span class="action-link" v-on:click="screen='login'">Login</span>
                                            </div>
                                        </div>

                                        <div v-if="screen=='verify-phone'" class="verify-phone-section form-section">
                                            <p>To confirm the identity of your account ( associated with {{ register_phone }}) we sent you an SMS with a validation code.</p>

                                            <div class="verifiy-code-fields text-center">
                                                <input type="text" v-model="phone_check_code" class="phone-code-field" autocomplete="false" autocomplete="off" v-on:keyup.13="checkVerificationCode">
                                            </div>
                                            <div class="text-center">
                                                <button id="check-verification-code" type="button" class="book-button" @click="checkVerificationCode" tabindex="10">Continue</button>

                                                <div class="book-action-links">
                                                    <a class="book-action-link" href="#" @click="verifyPhoneNumber">Resend Code</a>
                                                    <span class="link-separator">|</span>
                                                    <a class="book-action-link" href="#" @click="editPhoneNumber">Edit Number</a>
                                                </div>
                                            </div>
                                            <div v-if="phone_check_message" v-html="phone_check_message"></div>
                                        </div>

                                        <div v-if="screen=='user-exists'" class="user-exists-section form-section">
                                            <p>It looks like you’ve booked with Ring My Stylist before.</p>

                                            <div class="text-center">
                                                <div class="book-action-links">
                                                    <a class="book-action-link" href="#" @click="screen='login'">Click to Login</a>
                                                    <span class="link-separator"> -or- </span>
                                                    <a class="book-action-link" href="#" @click="onSendCode">Request Code</a>
                                                </div>
                                            </div>
                                        </div>
                                    </slot>
                                    <slot v-if="blocked" name="body text-center">
                                        <div class="alert alert-danger" role="alert">
                                            The stylist has been blocked your account.
                                        </div>
                                    </slot>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </modal>
    </div>
</template>

<style type="text/css">
    .stylist-name-dropdown {
        margin-bottom: 2px;
    }
    .new-book-modal .stylist-name-dropdown.show {
        display: inline-flex !important;
    }
    .stylist-name-dropdown .btn-secondary,
    .stylist-name-dropdown .btn-secondary:hover,
    .stylist-name-dropdown .btn-secondary:focus,
    .stylist-name-dropdown .btn-secondary:active,
    .stylist-name-dropdown.show > .btn-secondary.dropdown-toggle  {
        background-color: transparent !important;
        color: #333333 !important;
        border: none;
        font-weight: 700;
        padding: 0;
        font-size: 20px;
        outline: none;
        line-height: 20px;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
    }
    .stylist-name-dropdown .dropdown-menu {
        outline: none;
    }
    .stylist-name-dropdown .dropdown-toggle:after {
        display: inline-block;
        margin-left: 0.255em;
        vertical-align: 0.255em;
        content: "";
        border-top: 0.3em solid;
        border-right: 0.3em solid transparent;
        border-bottom: 0;
        border-left: 0.3em solid transparent;
    }
    .select-services-wrap h3.service-block-title {
        margin-top: 0;
    }
    .select-services-wrap .stylist-services-block {
        margin-bottom: 10px;
    }
    .select-services-wrap .service-category-list .category-services-list {
        padding-left: 25px;
    }
    .new-book-modal .category-services-list .switch {
        min-width: 40px;
    }
    @media(max-width: 767px) {
        .new-book-modal input[type=text],
        .new-book-modal input[type=email],
        .new-book-modal input[type=password] {
            font-size: 16px !important;
        }

        body.modal-open {
            height: 100vh !important;
            position: fixed;
            touch-action: none;
            -webkit-overflow-scrolling: none;
        }

        .book-date-time .free-hours {
            margin-bottom: 60px;
        }
    }
</style>

<script>
    import Vue from 'vue'
    import $ from 'jquery'
    import {eventBus} from "../main"
    import Datepicker from 'vuejs-datepicker';
    import moment from 'moment'
    import VueMask from 'v-mask'
    import { VueMaskDirective } from 'v-mask'
    import { DropdownPlugin } from 'bootstrap-vue'

    Vue.use(DropdownPlugin);
    Vue.use(VueMask);
    Vue.directive('mask', VueMaskDirective);

    export default {
        name: 'ModalBookingNew',
        data() {
            return {
                admin_url: document.getElementById('admin_url').value,
                stylist_alias: document.getElementById('stylist_alias').value,
                forgot_pass_url: 'https://book.ringmystylist.com/app/forgot-password',
                profile: {},
                logo: '',
                templateDirectory: '',
                loading: false,
                showModal: false,
                countries: [],
                phonePrefix: '+1',
                phone_check_code: '',
                link: {},
                user: {},
                userFirstName: '',
                userLastName: '',
                userEmail: '',
                user_token: '',
                free_hours: [],
                free_hours_group_names: ['morning','afternoon','evening'],
                free_hours_groups: {'morning':[],'afternoon':[],'evening':[]},
                booking_date: '',
                booking_date_time: '',
                booking_end_date_time: '',
                booking_date_existing: '',
                booking_notes: '',
                booking_reminders: [],
                booking_client_id: 0,
                booking_hour: '',
                booking_hour_existing: '',
                booking_services: [],
                booking_services_edit: [],
                booking_service_names: [],
                booking_services_total_cost: 0,
                booking_services_total_duration: 0,
                booking_special_event: 0,
                booking_services_and_up: false,
                available_dates: [],
                reminders: '',
                booking_status: 'unconfirmed',
                steps: ['calendar-wrapper'],
                agent: '',
                weekDays: ['sunday','monday','tuesday','wednesday','thursday','friday','saturday'],
                disabledDates: {
                    to: new Date(Date.now() - 8640000),
                    dates: [],
                    days: []
                },
                screen: 'step-1',
                slotsPos: [],
                slotsPosUpdates: 0,
                showMoreDates: false,
                login_email: '',
                login_password: '',
                login_message: '',
                register_name: '',
                register_email: '',
                register_password: '',
                register_phone: '',
                register_phone_mask: '',
                register_zip: '',
                register_message: '',
                show_prefixes_dropdown: 0,
                phone_check_message: '',
                appointment_message: '',
                appointment_saved: false,
                phone_verified: false,
                has_card: true,
                stripe: null,
                stripe_card: null,
                square_card: null,
                stripe_client_secret: '',
                getting_stripe_client_secret: false,
                cards_errors: '',
                linked: false,
                blocked: false,
                existing_user: false,
                square_application_id: '',
                paypal_client_token: '',
                paypal_account: null,
                paypal_environment: '',
                deposit_fee: 0,
                deposit_fee_order_id: 0,
                last_appointment_id: 0,
                reset_pass_message: '',
                unavailable_service_days: [],
                unavailable_service_name_days: [],
                login_phone_mask: '',
            }
        },
        props: {
            profile: Object,
            logo: String,
            templateDirectory: String,
            countries: Object,
            showModal: String,
            serviceId: Number
        },
        components: {
            Datepicker
        },
        created () {
            this.profile = this.$props.profile
            this.logo = this.$props.logo
            this.templateDirectory = this.$props.templateDirectory
            this.countries = this.$props.countries
            this.nonce = document.getElementById("phone-nonce").value
            this.agent = document.getElementById("agent").value
            this.blocked = this.profile.blocked;

            if(this.$props.serviceId){
                this.setSelectedService(this.$props.serviceId);
            }

            this.getNextAvailableDates();

            if(this.profile.phone_prefix){
                this.phonePrefix = (this.profile.phone_prefix.indexOf('+')==-1) ? '+' + this.profile.phone_prefix : this.profile.phone_prefix;
            }

            var available_future_days = (this.profile.work_settings && this.profile.work_settings.available_future_days > 0) ? this.profile.work_settings.available_future_days : 365;
            this.disabledDates.from = moment().add(available_future_days, 'days').toDate();
            console.log('profile', this.profile);
        },
        mounted() { 
            let self = this;
            var disabledWeekDays = [];

            this.weekDays.forEach(function(day, i){
                if(self.profile.work_settings[day] == 0){
                    disabledWeekDays.push(i);
                }
            });

            this.profile.free_days.forEach((day) => {
                self.disabledDates.dates.push(moment(day.date).toDate());
            });

            self.disabledDates.customPredictor = function(date){
                let date_formatted = new Date(date).toISOString().split('T')[0];
                if(disabledWeekDays.indexOf(date.getDay()) != -1 && self.profile.exception_days.indexOf(date_formatted) == -1){
                    return true;
                }
            };
        },
        methods: {
            onProfileChange(alias, name) {
                this.stylist_name = name;
                this.setInitialValues();
                this.getStylistProfile(alias);
            },
            setInitialValues() {
                this.booking_date = new Date;
                this.booking_date_time = '';
                this.booking_end_date_time = '';
                this.booking_date_existing = '';
                this.booking_services = [];
                this.booking_services_edit = [];
                this.booking_service_names = [];
                this.booking_services_total_cost = 0;
                this.booking_services_total_duration = 0;
            },
            getStylistProfile(profile_alias) {
                var data = new FormData();
                data.append('action', 'get_stylist_profile_data');
                data.append('stylist_alias', profile_alias);

                this.$http.post(this.admin_url, data).then(response => {
                    if(response.data.error==true) {
                        return;
                    }

                    this.profile = response.data.profile;
                    this.countries = response.data.countries;
                    this.countryPrefixes = response.data.prefixes;

                    this.disabledDates.days = [];
                    var disabledWeekDays = [];
                    this.weekDays.forEach((day, i) => {
                        if(this.profile.work_settings[day] == 0){
                            disabledWeekDays.push(i);
                        }
                    });

                    this.profile.free_days.forEach((day) => {
                        this.disabledDates.dates.push(moment(day.date).toDate());
                    });

                    self.disabledDates.customPredictor = function(date){
                        let date_formatted = new Date(date).toISOString().split('T')[0];
                        if(disabledWeekDays.indexOf(date.getDay()) != -1 && self.profile.exception_days.indexOf(date_formatted) == -1){
                            return true;
                        }
                    };

                    this.blocked = this.profile.blocked;
                    this.getNextAvailableDates();

                    if(this.profile.phone_prefix){
                        this.phonePrefix = (this.profile.phone_prefix.indexOf('+')==-1) ? '+' + this.profile.phone_prefix : this.profile.phone_prefix;
                    }

                    var available_future_days = (this.profile.work_settings && this.profile.work_settings.available_future_days > 0) ? this.profile.work_settings.available_future_days : 365;
                    this.disabledDates.from = moment().add(available_future_days, 'days').toDate();
                });
            },
            closeModal() {
                this.showModal = false;
                eventBus.$emit('updateShowModalState',false)
            },
            onAddService() {
                this.booking_services_edit = _.clone(this.booking_services);
                this.screen ='select-services';
            },
            onServicesClose() {
                this.booking_services_edit = [];
                this.screen ='step-1';
            },
            onServicesSave() {
                this.booking_services = _.clone(this.booking_services_edit);
                this.booking_services_edit = [];
                this.booking_service_names = [];
                this.booking_services_total_cost = 0;
                this.booking_services_total_duration = 0;

                var disabledWeekDays = [];
                this.weekDays.forEach((day, i) => {
                    if(this.profile.work_settings[day] == 0){
                        disabledWeekDays.push(i);
                    }
                });

                this.disabledDates.days = [];
                var self = this;
                this.disabledDates.customPredictor = function(date){
                    let date_formatted = new Date(date).toISOString().split('T')[0];
                    if(disabledWeekDays.indexOf(date.getDay()) != -1 && self.profile.exception_days.indexOf(date_formatted) == -1){
                        return true;
                    }
                };

                this.unavailable_service_name_days = [];

                this.booking_services.forEach((id) => {
                    this.setSelectedService(id);
                });

                this.showMoreDates = false;
                this.booking_date = '';
                this.booking_date_time = '';

                this.getNextAvailableDates();
                this.screen ='step-1';
                this.checkUserCard();
            },
            setSelectedService(id) {
                let service = this.profile.services.filter((el) => {
                    return (el.id == id);
                });

                if(!service[0]){
                    return;
                }

                service = service.pop();
                this.booking_service_names.push(service.name);
                this.booking_services_total_cost += parseInt(service.price_default);
                this.booking_services_total_duration += parseInt(service.duration_default);

                if(this.booking_services.indexOf(id) == -1) {
                    this.booking_services.push(id);
                }

                if(service.price_and_up == 1) {
                    this.booking_services_and_up = true;
                } else {
                    this.booking_services_and_up = false;
                }

                if(this.profile.policy.deposit!=0 && this.profile.policy.deposit_fee!=0){
                    if(this.profile.policy.deposit_type == 'fixed'){
                        this.deposit_fee = this.profile.policy.deposit_fee;
                    } else {
                        this.deposit_fee = (this.booking_services_total_cost * (this.profile.policy.deposit_fee/100)).toFixed(2);
                    }
                }

                let end_time = moment(this.booking_date_time).unix() + (this.booking_services_total_duration * 60);
                this.booking_end_date_time = moment.unix(end_time).format('YYYY-MM-DD h:mm a');

                this.unavailable_service_days = [];
                this.unavailable_service_name_days = [];

                this.booking_services.forEach((service_id) => {
                    let service = this.profile.services.filter((el) => {
                        return (el.id == service_id);
                    });

                    let restrictions = service[0].restrictions;

                    if(!restrictions) {
                        return;
                    }

                    let service_disabled_days = {
                        service: service[0].name,
                        days: []
                    };

                    this.weekDays.forEach((day, i) => {
                        if(restrictions[day] == 0 && this.unavailable_service_days.indexOf(i) == -1) {
                            this.unavailable_service_days.push(i);
                        }

                        if(restrictions[day] == 0){
                            service_disabled_days.days.push(day.charAt(0).toUpperCase() + day.slice(1));
                        }
                    });

                    this.unavailable_service_name_days.push(service_disabled_days);
                });
  
                this.disabledDates.days = [];
                this.weekDays.forEach((day, i) => {
                    if(this.unavailable_service_days.indexOf(i) != -1){
                        this.disabledDates.days.push(i);
                    }
                });
            },
            getNextAvailableDates() {
                var data = new FormData();
                data.append('action', 'get_stylist_free_days');
                data.append('stylist_id', this.profile.id);
                data.append('services_duration', this.booking_services_total_duration);
                data.append('current_datetime', moment().format('YYYY-MM-DD h:mm a'));
                data.append('disabled_days', this.disabledDates.days);

                this.$http.post(this.admin_url, data)
                .then(response => {
                    if(response.error == true){
                        return;
                    }

                    response.data.forEach((el, k) => {
                        this.slotsPos[k] = 0;
                    });

                    this.available_dates = response.data;
                });
            },
            slotsMoveLeft(index, step_length) {
                if(this.slotsPos[index] >= 0){
                    this.slotsPos[index] = 0;
                    return;
                }

                this.slotsPos[index] = (this.slotsPos[index]) ? this.slotsPos[index] : 0;
                this.slotsPos[index] += step_length;

                if(this.slotsPos[index] > 0){
                    this.slotsPos[index] = 0;
                }

                this.slotsPosUpdates++;
            },
            slotsMoveRight(index, step_length, limit_length) {
                if(this.slotsPos[index] <= limit_length) {
                    this.slotsPos[index] = limit_length;
                    this.slotsPosUpdates++;
                    return;
                }

                this.slotsPos[index] = (this.slotsPos[index]) ? this.slotsPos[index] : 0;
                this.slotsPos[index] -= step_length;

                if(this.slotsPos[index] < limit_length) {
                    this.slotsPos[index] = limit_length;
                }

                this.slotsPosUpdates++;
            },
            getStylistFreeHours(date) {
                var formatedDate = moment(date).format('YYYY-MM-DD');
                var data = new FormData();
                data.append('action', 'get_stylist_free_hours');
                data.append('stylist_id', this.profile.id);
                data.append('date', formatedDate);
                data.append('current_datetime', moment().format('YYYY-MM-DD h:mm a'));
                data.append('services_duration', this.booking_services_total_duration);

                this.booking_date = formatedDate;

                this.$http.post(this.admin_url, data)
                .then(response => {
                    if(response.error == true){
                        alert('error');
                    }else{
                        if(response.data.error==true) {
                            return;
                        } else {
                            this.free_hours = response.data.res.free_hours;
                            this.free_hours_groups = {'morning':[],'afternoon':[],'evening':[]};

                            let afternoon = moment(formatedDate+' 12:00:00').unix();
                            let evening = moment(formatedDate+' 17:00:00').unix();

                            this.free_hours.forEach((hour) => {
                                var dt = moment(hour, ["h:mm A"]).format("HH:mm");
                                let time = moment(formatedDate+' '+dt).unix();

                                if(time < afternoon){
                                    this.free_hours_groups['morning'].push(hour);
                                } else if(time >= afternoon && time < evening){
                                    this.free_hours_groups['afternoon'].push(hour);
                                } else {
                                    this.free_hours_groups['evening'].push(hour);
                                }
                            });

                            this.slotsPos = [];
                            this.free_hours_group_names.forEach((el, k) => {
                                this.slotsPos[k] = 0;
                            });
                        }
                    }
                });
            },
            onSelectTime(time, date) {
                if(date) {
                    this.booking_date = date;
                }

                this.showMoreDates = true;
                this.booking_hour = time;
                this.booking_date_time = this.booking_date+' '+this.booking_hour;

                var dt = moment(this.booking_hour, ["h:mm A"]).format("HH:mm");
                this.booking_date_time = moment(this.booking_date+' '+dt, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD H:mm:ss');

                let end_time = moment(this.booking_date_time, 'YYYY-MM-DD H:mm:ss').unix() + (this.booking_services_total_duration * 60);
                this.booking_end_date_time = moment.unix(end_time).format('YYYY-MM-DD H:mm:ss');

                if(this.profile.logged_in == true){
                    this.checkUserLink();
                    this.checkUserCard();
                    this.getClientPolicyAgreement();
                }
            },
            onEditTime() {
                this.booking_hour = '';
                this.booking_date_time = '';
                this.booking_end_date_time = '';
            },
            loginAppUser(e) {
                var data = new FormData();
                data.append('action', 'login_app_user');
                data.append('email', this.login_email);
                data.append('password', this.login_password);
                this.login_message = '';

                this.$http.post(this.admin_url,data)
                    .then(response => {
                        if(response.error == true){
                            this.login_message = '<div class="alert alert-danger">There is an error</div>';
                            return;
                        } else {
                            if(response.data.error==true) {
                                this.login_message = '<div class="alert alert-danger">'+response.data.message+'</div>';
                                return;
                            }

                            this.user = response.data.user;
                            this.profile.logged_in = true;
                            this.profile.policy = {};
                            this.has_card = true;
                            this.checkUserLink();
                            this.getClientPolicyAgreement();
                            this.screen = 'step-1';
                        }
                    });
                e.preventDefault();
            },
            sendResetPasswordEmail() {
                var data = new FormData();
                data.append('action', 'request_reset_password');
                data.append('email', this.login_email);
                this.reset_pass_message = '';

                this.$http.post(this.admin_url, data).then(response => {
                    if(response.error == true){
                        this.reset_pass_message = '<div class="alert alert-danger">There is an error</div>';
                        return;
                    }

                    if(response.data.error==true) {
                        this.reset_pass_message = '<div class="alert alert-danger">'+response.data.message+'</div>';
                        return;
                    }

                    this.reset_pass_message = '<div class="alert alert-success">'+response.data.message+'</div>';
                });
            },
            registerAppUser() {
                if(!this.register_name || !this.register_email || !this.register_password || !this.register_phone || !this.register_zip) {
                    this.register_message = '<div class="alert alert-danger">All the fields are required!</div>';
                    return;
                }

                var data = new FormData();
                data.append('action', 'register_app_user');
                data.append('full_name', this.register_name);
                data.append('email', this.register_email);
                data.append('password', this.register_password);
                data.append('phone_prefix', this.phonePrefix);
                data.append('phone', this.register_phone);
                data.append('zip', this.register_zip);
                this.register_message = '';

                this.$http.post(this.admin_url, data)
                .then(response => {
                    if(response.error == true){
                        this.register_message = '<div class="alert alert-danger">There is an error</div>';
                        this.screen = 'register';
                        return;
                    }

                    if(response.data.error==true) {
                        this.register_message = '<div class="alert alert-danger">'+response.data.message+'</div>';
                        this.screen = 'register';
                        return;
                    }

                    if(response.data.error==false && !response.data.user){
                        this.register_message = '<div class="alert alert-danger">There is an error. Please check your information and try again.</div>';
                        this.screen = 'register';
                        return;
                    }

                    this.user = response.data.user;
                    this.profile.logged_in = true;
                    this.sendUserInvite();
                    this.getClientPolicyAgreement();
                    this.screen = 'step-1';
                });
            },
            onSendCode() {
                this.verifyPhoneNumber();
                this.screen='verify-phone';
            },
            verifyPhoneNumber() {
                if(this.phone_verified == true){
                    this.registerAppUser();
                    return;
                }

                var data = new FormData();
                data.append('action', 'send_phone_verify_code');
                data.append('phone_prefix', this.phonePrefix);
                data.append('phone', this.register_phone);
                this.register_message = '';

                if((this.existing_user && !this.register_phone) || (!this.existing_user && (!this.register_name || !this.register_email || !this.register_password || !this.register_phone || !this.register_zip))) {
                    this.register_message = '<div class="alert alert-danger">Fill out the required fields!</div>';
                    return;
                }

                this.phone_check_code ='';
                this.phone_check_message = '';

                this.$http.post(this.admin_url, data)
                .then(response => {
                    if(response.error == true){
                        this.register_message = '<div class="alert alert-danger">There is an error</div>';
                        this.screen = 'register';
                        return;
                    }

                    if(response.data.error==true) {
                        this.register_message = '<div class="alert alert-danger">'+response.data.message+'</div>';
                        this.screen = 'register';
                    }

                    if(this.screen == 'verify-phone'){
                        this.phone_check_message = '<div class="alert alert-success">The code has been sent</div>';
                    }

                    this.screen = 'verify-phone';
                });
            },
            checkEmptyField(evt, length) {
                if(length > 0) {
                    return;
                }

                var target = evt.srcElement;

                while (target = target.previousElementSibling) {
                    if (target == null)
                        break;
                    if (target.tagName.toLowerCase() == "input") {
                        target.focus();
                        break;
                    }
                }
            },
            isNumber(evt, maxLength, model) {
                var target = evt.srcElement;

                if (this[model].length > maxLength) {
                    this[model] = this[model][0];
                }

                if (this[model].length >= maxLength) {
                    var next = target;

                    while (next = next.nextElementSibling) {
                        if (next == null)
                            break;
                        if (next.tagName.toLowerCase() == "input") {
                            next.focus();
                            break;
                        }
                    }
                }
            },
            checkExistingUser() {
                var data = new FormData();
                data.append('action', 'verify_existing_user');
                data.append('phone', this.register_phone);
                data.append('email',this.register_email);

                this.$http.post(this.admin_url,data)
                .then(response => {
                    if(response.error == true){
                        return;
                    }

                    if(response.data.error == true) {
                       return;
                    }

                    if(response.data.res.exists == true){
                        this.existing_user = true;
                        this.phonePrefix = response.data.res.phone_prefix;
                        this.register_phone = response.data.res.phone;
                        this.screen = 'user-exists';
                    }
                });
            },
            checkVerificationCode() {
                var data = new FormData();
                data.append('action', 'verify_phone_code');
                data.append('phone', this.register_phone);
                data.append('code',this.phone_check_code);
                data.append('existing_user',this.existing_user);

                this.$http.post(this.admin_url,data)
                .then(response => {
                    if(response.error == true){
                        this.phone_check_message = '<div class="alert alert-danger">There is an error</div>';
                        return;
                    }

                    if(response.data.error==true) {
                       this.phone_check_message = '<div class="alert alert-danger">'+response.data.msg+'</div>';
                    } else {
                        this.phone_verified = true;

                        if(!this.existing_user){
                            this.registerAppUser();
                        } else {
                            this.profile.logged_in = true;
                            this.screen = 'step-1';
                        }
                    }
                });
            },
            getClientPolicyAgreement() {
                var data = new FormData();
                data.append('action', 'get_client_policy_agreement');
                data.append('stylist_id', this.profile.id);

                this.$http.post(this.admin_url, data)
                .then(response => {
                    if(response.error == true){
                        return;
                    }

                    if(response.data.error==true) {
                       return;
                    }

                    this.profile.policy = response.data.policy;

                    this.checkUserCard();
                });
            },
            checkUserLink() {
                var data = new FormData();
                data.append('action', 'check_user_link');
                data.append('stylist_id', this.profile.id);

                this.$http.post(this.admin_url, data)
                .then(response => {
                    if(response.error == true){
                        return;
                    }

                    if(response.data.error==true) {
                       return;
                    }

                    this.linked = response.data.linked;
                    this.blocked = response.data.blocked;

                    if(!response.data.linked){
                        this.sendUserInvite();
                    }
                });
            },
            hasPolicyEnabled() {
                return (this.profile.policy && ((this.profile.policy.cancel==1 && this.profile.policy.cancel_fee>0) || this.profile.policy.deposit==1 && this.profile.policy.deposit_fee>0) && this.profile.accept_payments==1 && (this.profile.accept_stripe || this.profile.accept_square || this.profile.accept_paypal));
            },
            checkUserCard() {
                if(!this.hasPolicyEnabled()){
                    return;
                }

                var processor = '';

                if(this.profile.accept_stripe) {
                    processor = 'stripe';
                } else if(this.profile.accept_square) {
                    processor = 'square';
                } if(this.profile.accept_paypal) {
                    processor = 'paypal';
                }

                var data = new FormData();
                data.append('action', 'check_client_cards');
                data.append('processor', processor);
                data.append('stylist_id', this.profile.id);

                this.$http.post(this.admin_url, data)
                .then(response => {
                    if(response.error == true){
                        return;
                    }

                    if(response.data.error==true) {
                        this.has_card = false;
                        this.displayCardForm();
                        return;
                    }

                    if(!response.data.has_card){
                        this.square_application_id = response.data.application_id;
                        this.paypal_client_token = response.data.client_token;
                        this.paypal_environment = response.data.environment;
                        this.has_card = false;
                        this.displayCardForm();
                    }
                });
            },
            sendUserInvite() {
                var data = new FormData();
                data.append('action', 'send_user_invite');
                data.append('stylist_id', this.profile.id);

                this.$http.post(this.admin_url, data);
            },
            getStripeSetupIntent() {
                if(this.getting_stripe_client_secret) {
                    return;
                }

                var data = new FormData();
                data.append('action', 'get_stripe_setup_intent');
                this.getting_stripe_client_secret = true;

                this.$http.post(this.admin_url, data).then(response => {
                    if(response.error == true){
                        return;
                    }

                    this.stripe_client_secret = response.data.client_secret;
                    this.getting_stripe_client_secret = false;
                });
            },
            displayCardForm() {
                if(this.profile.accept_payments == 0){
                    return;
                }

                //Generate the Stripe card form
                if(this.profile.accept_stripe){
                    if(!this.$refs.card_form){
                        setTimeout(() => {
                            this.displayCardForm();
                        }, 100);
                        return;
                    }

                    this.stripe = Stripe(this.profile.stripe_public_key);

                    var elements = this.stripe.elements();
                    this.stripe_card = elements.create('card');
                    this.stripe_card.mount(this.$refs.card_form);

                    this.stripe_card.addEventListener('change', (event) => {
                        if (event.error) {
                            this.cards_errors = event.error.message;
                        } else {
                            this.cards_errors = '';
                        }
                    });

                    this.getStripeSetupIntent();

                //Generate the Square card Form
                } else if(this.profile.accept_square){
                    if(!this.$refs.card_form_square){
                        setTimeout(() => {
                            this.displayCardForm();
                        }, 100);
                        return;
                    }

                    this.square_card = new SqPaymentForm({
                        applicationId: this.square_application_id,
                        inputClass: 'sq-input',
                        autoBuild: false,
                        inputStyles: [{
                            fontSize: '16px',
                            lineHeight: '24px',
                            padding: '5px',
                            placeholderColor: '#a0a0a0',
                            backgroundColor: 'transparent',
                        }],
                        cardNumber: {
                           elementId: 'sq-card-number',
                           placeholder: 'Card Number'
                        },
                        cvv: {
                           elementId: 'sq-cvv',
                           placeholder: 'CVV'
                        },
                        expirationDate: {
                           elementId: 'sq-expiration-date',
                           placeholder: 'MM/YY'
                        },
                        postalCode: {
                           elementId: 'sq-postal-code',
                           placeholder: 'Postal'
                        },
                        callbacks: {
                            cardNonceResponseReceived: (errors, nonce, cardData) => {
                                self.cards_errors = '';

                                if (errors) {
                                    errors.forEach(function (error) {
                                        self.cards_errors += error.message;
                                    });

                                    return;
                                }

                                var data = new FormData();
                                data.append('action', 'save_client_card');
                                data.append('card_nonce', nonce);
                                data.append('stylist_id', this.profile.id);
                                data.append('processor', 'square');
                                this.loading = true;

                                this.$http.post(this.admin_url, data)
                                .then(response => {
                                    this.loading = false;

                                    if(response.error == true){
                                        return;
                                    }

                                    if(response.data.error==true) {
                                       return;
                                    }

                                    this.has_card = true;
                                    this.saveAppointment();
                                });
                            }
                        }
                    });

                    this.square_card.build();

                //Generate the PayPal vault form
                } else if(this.profile.accept_paypal){
                    if(!this.$refs.card_form_paypal){
                        setTimeout(() => {
                            this.displayCardForm();
                        }, 100);
                        return;
                    }

                    if(this.paypal_account) {
                        return;
                    }

                    let paypal_client = {};
                    paypal_client[this.paypal_environment] = this.paypal_client_token;

                    this.paypal_account = paypal.Button.render({
                        braintree: braintree,
                        client: paypal_client,
                        env: this.paypal_environment,
                        commit: true,
                        payment: function (data, actions) {
                            return actions.braintree.create({
                                flow: 'vault',
                                enableShippingAddress: false,
                                shippingAddressEditable: false,
                                landingPageType: 'billing',
                            });
                        },
                        onAuthorize: (payload) => {
                            var data = new FormData();
                            data.append('action', 'save_client_card');
                            data.append('payment_method_nonce', payload.nonce);
                            data.append('stylist_id', this.profile.id);
                            data.append('processor', 'paypal');
                            this.loading = true;

                            this.$http.post(this.admin_url, data)
                            .then(response => {
                                this.loading = false;

                                if(response.error == true){
                                    return;
                                }

                                if(response.data.error==true) {
                                   return;
                                }

                                this.has_card = true;
                                this.appointment_message = '';
                            });
                        },
                    }, '#paypal-button');
                }
            },
            saveCard() {
                if(this.loading) {
                    return;
                }

                //Save the card is Stripe
                if(this.profile.accept_payments && this.profile.accept_stripe){
                    this.stripe.confirmCardSetup(
                        this.stripe_client_secret,
                        {
                            payment_method: {
                                card: this.stripe_card,
                                billing_details: {},
                            },
                        }
                    ).then((result) => {
                        if (result.error) {
                            this.cards_errors = result.error.message;
                            return;
                        } else {
                            this.loading = false;
                            this.has_card = true;
                            this.saveAppointment();
                        }
                    });

                //Save the card in Square
                } else if(this.profile.accept_payments && this.profile.accept_square){
                    this.square_card.requestCardNonce();
                }
                else if (this.profile.accept_payments && this.profile.accept_paypal) {
                    if(!this.has_card) {
                        this.appointment_message = '<div class="alert alert-danger">You have to add the PayPal account first.</div>';
                        return;
                    }

                    this.saveAppointment();
                }
            },
            handleSaveAppointment() {
                if(!this.linked && this.profile.work_settings.accept_new_clients === 0) {
                    let message = (this.profile.work_settings.accept_new_clients_text) ? 
                        this.profile.work_settings.accept_new_clients_text : 
                        'Not accepting new clients. Only book if you are an existing client of mine. Thank you!';
                    this.appointment_message = '<div class="alert alert-danger">'+message+'</div>';
                    return;
                }

                if(this.has_card == false) {
                    this.saveCard();
                    return;
                }

                this.saveAppointment();
            },
            saveAppointment(){
                if(this.loading) {
                    return;
                }

                var data = new FormData();

                data.append('action', 'save_client_appointment');
                data.append('vue', true);

                data.append('date', this.booking_date);
                data.append('hour', this.booking_hour);
                data.append('services', this.booking_services);
                data.append('user_id', this.profile.id);
                data.append('status', 'unconfirmed');
                data.append('notes', this.booking_notes);
                data.append('total_duration', this.booking_services_total_duration);

                if(this.deposit_fee){
                    data.append('deposit_fee', this.deposit_fee);
                }

                this.appointment_message = '';
                this.loading = true;

                this.$http.post(this.admin_url, data)
                .then(response => {
                    this.loading = false;

                    if(response.error == true){
                        alert('error');
                    }else{
                        if(response.data.error==true) {
                            this.appointment_message = '<div class="alert alert-danger">'+response.data.msg+'</div>';
                            return;
                        }

                        this.last_appointment_id = response.data.appointment_id;
                        this.appointment_saved = true;
                    }
                });
            },
            updateRegisterPhone() {
                this.register_phone = this.register_phone_mask.replace(/\D/g,'');
            },
            parseISOLocal(s) {
                var b = s.split(/\D/);
                return new Date(b[0], b[1]-1, b[2], b[3], b[4], b[5]);
            },
            getFormattedDate(date, format) {
                return moment(date, 'YYYY-MM-DD H:mm:ss').format(format);
            },
            onRequestCode() {
                var data = new FormData();
                data.append('action', 'verify_existing_user');
                data.append('phone', this.login_phone_mask.replace(/\D/g,''));

                this.$http.post(this.admin_url, data).then(response => {
                    if(response.error == true){
                        this.phone_check_message = '<div class="alert alert-danger">Error checking the phone</div>';
                        return;
                    }

                    if(response.data.error == true) {
                        this.phone_check_message = '<div class="alert alert-danger">'+response.data.message+'</div>';
                        return;
                    }

                    if(response.data.res.exists == true){
                        this.existing_user = true;
                        this.phonePrefix = response.data.res.phone_prefix;
                        this.register_phone = response.data.res.phone;
                        this.onSendCode();
                    } else {
                        this.phone_check_message = '<div class="alert alert-danger">The phone does not match any user</div>';
                    }
                });
            },
            editPhoneNumber() {
                this.screen=(!this.login_phone_mask) ? 'register' : 'request-code';
                this.phone_check_message = '';
            },
        }
    }
</script>